import clsx from "clsx";

import classes from "./styles.module.scss";

import type { IInfiniteVisitHistoriesResponse } from "@api/infiniteDropdowns/types";
import { Typography } from "@components/atoms/typography";
import { Chip } from "@components/atoms/chip";
import type { IDiagnosisConditionType } from "@/templates/writeSummaryNote";

export function VisitHistories({
  diagnosis,
  value,
  ...props
}: IInfiniteVisitHistoriesResponse) {
  return (
    <div className={classes.historyCard}>
      <div className={clsx(classes.historyCard__top)}>
        <Typography variant={"h6"}>{value}</Typography>
        <Chip
          name={
            (props?.diagnosis_type?.key as IDiagnosisConditionType) ||
            "no-detect"
          }
          value={props?.diagnosis_type?.value || "نمی توان اظهار نظر کرد!"}
        />
      </div>
      <Typography
        variant={"description1"}
        className={clsx(classes.historyCard__text)}
      >
        {diagnosis}
      </Typography>
    </div>
  );
}
